import React from "react";
import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

const onUserClick = (user, props) => props.onUserClick(user);

const UsersList = (props) => {
    let _class = `filter-benefits-button font-size-p8 gotham-xn-medium dark ${props.isMobile ? ' mobile-filter-button' : ''}`;
    let ageOver12Guests = props.guestDetails.filter((guest) => guest.PassengerDetail.Age > 12);
    let row = (
        <fieldset>
            <legend className="visuallyhidden">Select a Guest</legend>
            <div className='available-user-row row justify-content-center text-center list-style'>
                {
                    props.showAll === true ?
                        <div className='user-tile button-checkbox col-sm-12 col-md-3 filter-li'>
                            <span class='user-list-item'>
                                <input id='All-userList' checked={props.selectedGuest === 'All Guests'} onClick={(props.selectedGuest !== 'All Guests') ? onUserClick.bind(this, 'All Guests', props) : undefined} type="radio" name="select-guest" />
                                <label htmlFor={'All-userList'} class={`img-responsive-wrapper  datecard-hover title-hover ${(props.selectedGuest === 'All Guests') ? 'selected-day-card' : ''}   ${_class}`}>
                                    All Guests
                            </label>
                            </span>
                        </div> : null
                }{
                    ageOver12Guests.map((user, i) => {
                        let userName = user.PassengerDetail.Name;
                        let _label = `${userName.FirstName} ${userName.LastName}`;
                        let dispLabel = startCase(toLower(_label));
                        let isSelected = (props.selectedGuestDetails) ? (props.selectedGuestDetails.PaxId === user.PaxId && props.selectedGuest === _label) : false;
                        let random = Math.random();

                        return (<div className='user-tile button-checkbox col-sm-12 col-md-3 filter-li'>
                            <span class='user-list-item'>
                                <input id={'userlist-' + i + random} checked={isSelected} onClick={!isSelected ? onUserClick.bind(this, user, props) : undefined} type="radio" name="select-guest" />
                                <label htmlFor={'userlist-' + i + random} data-test-id="guest-button" className={`font-size-p8 gotham-xn-medium datecard-hover title-hover ${(isSelected) ? 'selected-day-card' : ''}  ${_class}`}>{dispLabel}</label>
                            </span>
                        </div>)
                    }
                    )}
            </div>
        </fieldset>)
    return (row)
}

export default UsersList;
